import React, { useContext } from 'react';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

import { ContentContext } from 'Components/hooks/context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SmartText from '@reuters-graphics/react-smart-text';

const Legend = (props) => {
  const content = useContext(ContentContext).common.linkbox;
  return (
    <div className='legend mx-auto'>
      <div>
        <p><SmartText source={content.legend.peak} /></p>
        <p><FontAwesomeIcon icon={faCaretUp} /> <SmartText source={content.legend.increasing} /></p>
        <p><FontAwesomeIcon icon={faCaretDown} /> <SmartText source={content.legend.decreasing} /></p>
      </div>
    </div>
  );
};

export default React.memo(Legend);
